import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { CollectionServer, deleteInArray, GET, IfElse, Model, QueryDetail, QueryOrder, updateInArray } from 'fennec-ui'
import { errorCatch, POST } from 'fennec-ui'

export default function TantsiSerii(props) {
    const [loading, setLoading] = useState(false);
    const { auth, object, sourceKey, create } = props;
    const dispatch = useDispatch();

    const filters = () => [
        // {
           
        // },
    ];

    return (
        <>
            <CollectionServer
                name={"TantsiSerii"}
                auth={auth}
                size="small"
                source={`/api/serii${(!create)?"/com":""}/tantsi/${object.ID}`}
                filters={filters}
                mode={"list"}
                render={(item, idx, { setCollection, setCollectionItem, update }) => {
                    return (
                        <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", width: "100%", paddingRight: "18px" }}>
                            <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                    <span style={{ fontWeight: "600" }}>{item.tanets.nazvanie}</span>
                                </div>
                            </div>
                        </div>
                    )
                }}
                collectionActions={() => [
                    ...IfElse(
                        (create == true), [
                        {
                            action: (values, unlock, close, { collection, setCollection }) => {
                                let o = {
                                    seriyaID: object.ID,
                                    tanetsID: values.tanetsID,
                                }
                                POST(auth, `/api/serii/add-tanets`, o,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            form: Model,
                            meta: [
                                {
                                    label: "Танец",
                                    name: "tanets",
                                    type: "object",
                                    relation: {
                                        display: (item) => {
                                            return item.nazvanie
                                        },
                                        reference: { object: "Tantsi", property: "ID" },
                                        type: "many-one",
                                    },
                                    queryFilter: [
                                        QueryDetail("model"),
                                        QueryOrder("nazvanie", "ASC")
                                    ]
                                }
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Добавить танец",
                            modal: {
                                width: "600px",
                                title: "Добавить танец",
                            }
                        }], []),
                ]}
                modelActions={(item) => [
                    ...IfElse(
                        (create == true), [
                        {
                            danger: true,
                            title: "Удалить",
                            action: (values, unlock, close, { collection, setCollection }) => {
                                GET(auth, `/api/tanets-v-serii/delete/${item.ID}`,
                                    () => setCollection(deleteInArray(collection, item)), errorCatch
                                );
                            },
                        }], []),
                ]}
            />
        </>
    );
}
